const ApplicationLogo = props => (
  <div {...props}>
    <div className="flex h-full items-center gap-4">
      <img 
        src="/logos/uncoActiva/isotipo/Isotipo UNCo Activa 2026 Celeste.svg" 
        alt="Isotipo UNCo Activa"
        className="h-full"
        >
      </img>
      <img
        src="/logos/uncoActiva/logotipo/Logotipo UNCo Activa 2026 Lima.svg" 
        alt="Logotipo UNCo Activa"
        className="h-2/3"
      >
      </img>
    
    </div>
  </div>
  
)

export default ApplicationLogo
